import { render, staticRenderFns } from "./FileStack.vue?vue&type=template&id=dbff9b50&"
import script from "./FileStack.vue?vue&type=script&lang=js&"
export * from "./FileStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports